import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import { Link, NavLink, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Pagination from "../General/Pagination";
import SupportTopMenu from "./SupportTopMenu";

function TicketsClose() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  useParams();

  useEffect(() => {
    setLoading(true);
    const data = {
      AccessKey,
      UserID,
      pageNo,
      pageSize,
      Status: "Closed",
    };

    axios({
      method: "post",
      url: config.base_url + "Support/GetSupportTicket",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setTickets(response.data.ListofTickets || []);
          setTotalRecords(response.data.totalRecords || 0);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [pageNo, pageSize, AccessKey, UserID]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLogs = () => {
    if (tickets.length > 0) {
      return tickets.map((item, index) => (
        <tr key={index}>
          <td>{item.TicketID}</td>
          <td>{moment(item.Dated).format("DD MMM, YYYY HH:mm:ss")}</td>
          <td>{item.TicketType}</td>
          <td>{item.Subject}</td>
          <td>{item.Status}</td>
          <td>
            <NavLink
              to={`/support/ticket-detail/${item.ID}`}
              className="button-detail"
            >
              Check
              <span>
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </NavLink>
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="6">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <SupportTopMenu />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/support/raise-ticket">Support</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Closed
                  </li>
                </ol>
              </nav>
              <div className="page-title">Closed</div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body table_card">
              <div className="card-table">
                <div className="card-inner">
                  {loading ? (
                    <div className="p-5 text-center">
                      <Spinner animation="border" role="status" />
                    </div>
                  ) : (
                    <table className="table table-theme">
                      <thead>
                        <tr>
                          <th>Ticket ID</th>
                          <th>Date</th>
                          <th>Department</th>
                          <th>Subject</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>{renderLogs()}</tbody>
                    </table>
                  )}

                  {totalRecords > 10 && (
                    <div className="pagination-wrap">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label className="me-2" style={{ fontSize: "15px" }}>
                              Page size
                            </label>
                            <div className="form-group">
                              <select
                                className="form-select"
                                style={{ width: "100px" }}
                                value={pageSize}
                                onChange={(e) => {
                                  setPageNo(1);
                                  setPageSize(parseInt(e.target.value, 10));
                                }}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketsClose;
